export const DEFAULT_SELECTED: string = 'defaultselected'
